module.exports = __webpack_public_path__ + "static/img/wzry-enterpriseCulture1.eabb81ea.png";